import {
  Container,
  Flex,
  Box,
  Heading,
  Text,
  IconButton,
  Button,
  VStack,
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputLeftElement,
  Textarea,
  Link,
  Alert,
  AlertIcon,
} from "@chakra-ui/react";
import { MdOutlineEmail } from "react-icons/md";
import { BsPerson, BsTelephone } from "react-icons/bs";
import { CgOrganisation } from "react-icons/cg";
import React, { useEffect, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { CONTACT_PAGE_QUERY } from "@/apollo/queries";
import { CREATE_CONTACT_FORM_MUTATION } from "@/apollo/mutations";
import { useMutation, useQuery } from "@apollo/client";
import NextLink from "next/link";
import Banner from "@/components/Banner";
import SEOHead from "@/components/SEO";
import Loader from "@/components/Loader";

const initState = {
  email: "",
  full_name: "",
  message: "",
  organization: "",
  phone: "",
};

export default function contact() {
  const recaptchaRef = React.useRef(null);

  const [inputs, setInputs] = useState(initState);
  const [isDisabled, setIsDisabled] = useState(true);
  const [isSubmiited, setIsSubmitted] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [captchaError, setCaptchaError] = useState(null);

  const { loading, error, data } = useQuery(CONTACT_PAGE_QUERY);
  const [
    createContactFromList,
    { loading: contactLoading, data: contactData, error: contactError },
  ] = useMutation(CREATE_CONTACT_FORM_MUTATION);

  useEffect(() => {
    if (contactData) {
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 7000);
    }
  }, [contactData]);

  if (loading) {
    return <Loader />;
  }

  if (error || contactError) {
    console.error(error && error);
    console.error(contactError && contactError);
    return null;
  }

  const { Title, Description, MainSec, locations, social_links, SEO } =
    data.contactPage.data.attributes;

  const handleChange = ({ target: { name, value } }) => {
    setInputs((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    try {
      event.preventDefault();
      setIsSubmitted(true);

      // Check phone number 8 digits se upper hai ya nahi
      if (inputs.phone.length < 8) {
        setCaptchaError(
          "Please update your phone number as it appears to be invalid."
        );
        return;
      }
      // create contact us
      createContactFromList({
        variables: {
          data: inputs,
        },
      }).then(({ errors }) => {
        if (!errors) {
          console.log("fssggsggs");
          setIsSubmitted(false);
        }
      });
    } finally {
      setIsDisabled(true);
      setIsSubmitted(false);
      setInputs(initState);
      recaptchaRef.current.reset();
    }
  };

  const onReCAPTCHAChange = async (token) => {
    try {
      if (!token) {
        setCaptchaError("captcha verification invalid or expired.");
        return;
      } else {
        const response = await fetch("/api/verifyCaptchaToken", {
          method: "POST",
          body: JSON.stringify({ captcha: token }),
          headers: {
            "Content-Type": "application/json",
          },
        });
        if (response.ok) {
          setIsDisabled(false);
        } else {
          const error = await response.json();
          // throw new Error(error.message);
          console.error(error.message);
          setCaptchaError(error.message);
        }
      }
    } catch (error) {
      console.error(error);
      setCaptchaError("something went wrong.");
    }
  };

  return (
    <>
      <SEOHead title={SEO.pageTitle} description={SEO.pageDescription} />
      <Banner data={MainSec} classNameparent="contactOverlay" />
      <Box px={{ base: 5, md: 8, xl: 5 }} pt={{ base: 10, md: 16 }}>
        <Container
          as={Container}
          maxW="7xl"
          centerContent
          overflow="hidden"
          p={0}
        >
          <Flex flexWrap={{ base: "wrap", lg: "nowrap" }} w={"100%"}>
            <Box
              borderRadius="lg"
              rounded="lg"
              boxShadow={{ base: "unset", md: "xl" }}
              borderColor={"white.20"}
              borderWidth={{ base: "inherit", md: "2px" }}
              mb={{ base: 1, md: 8 }}
              w={"100%"}
            >
              <Box
                py={5}
                px={{ base: 0, md: 5 }}
                display={"flex"}
                gap={4}
                flexWrap={{ base: "wrap", sm: "wrap", md: "nowrap" }}
                w={"100%"}
                alignItems={{ base: "unset", lg: "center" }}
              >
                <Flex
                  bg={
                    "linear-gradient(135deg, hsl(0deg 40% 95%) 0%, hsl(208deg 93% 87%) 100%, hsl(32deg 97% 59%) 100%, hsl(0deg 0% 100%) 100%)"
                  }
                  rounded="lg"
                  p={5}
                  w={{ base: "100%", lg: "40%" }}
                  flexDirection={"column"}
                  justifyContent={"center"}
                  marginBottom={"5em"}
                >
                  <Heading
                    fontSize={{ base: "2xl", xl: "3xl" }}
                    mb={"5"}
                    fontWeight={"medium"}
                    color={"blue.10"}
                  >
                    {Title}
                  </Heading>
                  <Text fontSize={{ base: "sm", xl: "md" }} color="gray.10">
                    {Description}
                  </Text>

                  {/* Social Icons Start*/}
                  <Box pt={8}>
                    <VStack pl={0} spacing={3} alignItems="flex-start">
                      {social_links.data.map((s, index) => {
                        const { path, viewbox, Name, Fill } = s.attributes.Icon;
                        return (
                          <Link
                            href={s.attributes.url}
                            style={{ textDecoration: "none" }}
                          >
                            <Flex
                              alignItems={"center"}
                              fontWeight={"500"}
                              color={"blue.10"}
                              _hover={{
                                button: {
                                  bg: "transparent",
                                  color: "orange.10",
                                },
                                p: { color: "orange.10" },
                              }}
                            >
                              <IconButton
                                aria-label={Name}
                                mr={"2"}
                                variant="ghost"
                                size="md"
                                color={"orange.10"}
                                isRound={true}
                                icon={
                                  <svg
                                    width="24"
                                    height="24"
                                    className="chakra-icon"
                                    viewBox={viewbox || "0 0 24 24"}
                                    fill={Fill}
                                    dangerouslySetInnerHTML={{ __html: path }}
                                  />
                                }
                                _hover={{
                                  button: { bg: "transparent" },
                                }}
                              />
                              <Text fontSize={{ base: "sm", xl: "md" }}>
                                {s.attributes.value}
                              </Text>
                            </Flex>
                          </Link>
                        );
                      })}
                    </VStack>
                  </Box>
                  {/* Social Icons End */}

                  {/* Locations Start */}
                  <Box pt={5}>
                    <VStack pl={0} spacing={3} alignItems="flex-start">
                      {locations.data.map((s, index) => {
                        const { path, viewbox, Name, Fill } = s.attributes.SVG;
                        return (
                          <Flex alignItems={"center"}>
                            <IconButton
                              aria-label={Name}
                              mr={"2"}
                              variant="ghost"
                              size="md"
                              color={"orange.10"}
                              isRound={true}
                              icon={
                                <svg
                                  width="24"
                                  height="24"
                                  className="chakra-icon"
                                  viewBox={viewbox || "0 0 24 24"}
                                  fill={Fill}
                                  dangerouslySetInnerHTML={{ __html: path }}
                                />
                              }
                              _hover={{
                                button: {
                                  bg: "transparent",
                                  color: "orange.10",
                                },
                              }}
                            />
                            <Text
                              fontSize={{ base: "sm", xl: "md" }}
                              color={"gray.10"}
                            >
                              {s.attributes.Address}
                            </Text>
                          </Flex>
                        );
                      })}
                    </VStack>
                  </Box>
                  {/* Locations End */}
                </Flex>

                <Box
                  bg="white"
                  borderRadius="lg"
                  w={{ base: "100%", lg: "60%" }}
                >
                  <Box m={0} color="#0B0E3F">
                    <form onSubmit={handleSubmit}>
                      <VStack spacing={5}>
                        <Flex
                          w={"100%"}
                          gap={"4"}
                          flexWrap={{ base: "wrap", lg: "nowrap" }}
                        >
                          <FormControl id="name" isRequired>
                            <FormLabel
                              fontSize={"md"}
                              fontWeight={"normal"}
                              color={"blue.10"}
                            >
                              Full Name
                            </FormLabel>
                            <InputGroup borderColor="#E0E1E7">
                              <InputLeftElement
                                pointerEvents="none"
                                height={"45px"}
                                children={<BsPerson color="gray.800" />}
                              />
                              <Input
                                type="text"
                                name="full_name"
                                size="lg"
                                value={inputs.full_name}
                                onChange={handleChange}
                              />
                            </InputGroup>
                          </FormControl>
                          <FormControl id="org">
                            <FormLabel
                              fontSize={"md"}
                              fontWeight={"normal"}
                              color={"blue.10"}
                            >
                              Organization
                            </FormLabel>
                            <InputGroup borderColor="#E0E1E7">
                              <InputLeftElement
                                pointerEvents="none"
                                height={"45px"}
                                children={<CgOrganisation color="gray.800" />}
                              />
                              <Input
                                type="text"
                                name="organization"
                                size="lg"
                                value={inputs.organization}
                                onChange={handleChange}
                              />
                            </InputGroup>
                          </FormControl>
                        </Flex>
                        <Flex
                          w={"100%"}
                          gap={"4"}
                          flexWrap={{ base: "wrap", lg: "nowrap" }}
                        >
                          <FormControl id="email" mr={"2"} isRequired>
                            <FormLabel
                              fontSize={"md"}
                              fontWeight={"normal"}
                              color={"blue.10"}
                            >
                              E-Mail
                            </FormLabel>
                            <InputGroup borderColor="#E0E1E7">
                              <InputLeftElement
                                pointerEvents="none"
                                height={"45px"}
                                children={<MdOutlineEmail color="gray.800" />}
                              />
                              <Input
                                type="email"
                                name="email"
                                size="lg"
                                value={inputs.email}
                                onChange={handleChange}
                              />
                            </InputGroup>
                          </FormControl>
                          <FormControl id="phone" isRequired>
                            <FormLabel
                              fontSize={"md"}
                              fontWeight={"normal"}
                              color={"blue.10"}
                            >
                              Phone
                            </FormLabel>
                            <PhoneInput
                              className="phone_input"
                              inputProps={{
                                name: "phone",
                                required: true,
                              }}
                              country={"in"}
                              value={inputs.phone}
                              onChange={(value) =>
                                handleChange({
                                  target: { name: "phone", value },
                                })
                              }
                            />
                          </FormControl>
                        </Flex>
                        <FormControl id="message" isRequired>
                          <Flex>
                            <FormLabel
                              fontSize={"md"}
                              fontWeight={"normal"}
                              color={"blue.10"}
                            >
                              Message
                            </FormLabel>{" "}
                            <Text color="rgba(0, 0, 0, 0.30)">
                              ( To apply for a job,{" "}
                              <NextLink href="/careers">
                                <Link color="blue.500" >click here</Link>
                              </NextLink>{" "}
                              )
                            </Text>
                          </Flex>
                          <Textarea
                            name="message"
                            borderColor="gray.300"
                            _hover={{
                              borderRadius: "gray.300",
                            }}
                            value={inputs.message}
                            placeholder="How we can help you?"
                            onChange={handleChange}
                            rows={5}
                          />
                        </FormControl>

                        {/* reCAPTCHA verification */}
                        <ReCAPTCHA
                          style={{ alignSelf: "baseline" }}
                          ref={recaptchaRef}
                          size="normal"
                          sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
                          onChange={onReCAPTCHAChange}
                        />

                        {captchaError && (
                          <Text color={"red.600"}>{captchaError}</Text>
                        )}

                        <FormControl
                          textAlign={"center"}
                          id="btnSubmit"
                          display={"flex"}
                          justifyContent={{ base: "center", md: "flex-end" }}
                        >
                          <Button
                            type="submit"
                            variant="solid"
                            bg="blue.10"
                            rounded={"md"}
                            color={"white"}
                            size="lg"
                            width="200px"
                            height="50px"
                            marginTop={{ base: 10, md: 5 }}
                            _hover={{
                              bg: "transparent",
                              color: "blue.10",
                              border: "1px",
                              borderColor: "blue.10",
                              borderStyle: "solid",
                            }}
                            isLoading={isSubmiited}
                            isDisabled={isDisabled}
                          >
                            Submit
                          </Button>
                        </FormControl>
                        {showAlert && (
                          <Alert status="success" variant="left-accent">
                            <AlertIcon />
                            Thanks for submitting contact form. Our team will
                            get back to you soon. <br /> We will review your
                            application and will contact you if there is a good
                            match.
                          </Alert>
                        )}
                      </VStack>
                    </form>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Flex>
        </Container>
      </Box>
    </>
  );
}
